var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditPencil = function SvgEditPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m11.353.384 2.263 2.263a1.313 1.313 0 0 1 0 1.856l-1.03 1.03-4.118-4.12L9.498.385a1.31 1.31 0 0 1 1.855 0M1.44 8.44l6.1-6.098 4.118 4.119L5.56 12.56a.44.44 0 0 1-.194.112L.553 13.984a.438.438 0 0 1-.537-.537l1.312-4.813a.44.44 0 0 1 .112-.194",
    clipRule: "evenodd"
  })));
};
export default SvgEditPencil;